/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Проп содержит опции для конфига chart.js
 * Эти часто используемые опции вынесены в отдельный проп для удобства конфигурации
 * */

export var EDatasetColors;
(function (EDatasetColors) {
  EDatasetColors["RED"] = "red";
  EDatasetColors["BLUE"] = "blue";
  EDatasetColors["ORANGE"] = "orange";
})(EDatasetColors || (EDatasetColors = {}));
export var EDatasetColorTypes;
(function (EDatasetColorTypes) {
  EDatasetColorTypes["GRADIENT"] = "gradient";
  EDatasetColorTypes["SOLID"] = "solid";
  EDatasetColorTypes["TRANSPARENT"] = "transparent";
})(EDatasetColorTypes || (EDatasetColorTypes = {}));